import { useAttributeReviewValueDomainSearchQuery } from "@/graphql/generated";

export function usePoolSearch(text: string) {
  const searching = text.trim().length > 1;
  const { data } = useAttributeReviewValueDomainSearchQuery(
    { query: text, limit: 10 },
    { enabled: searching },
  );
  return {
    searching,
    keys: (data?.attributeReviewValueDomainSearch.items ?? []).map(
      (item) => item.domainKey,
    ),
  };
}
